import {resolveApiUrl,validUToken} from 'utils/common';
import {SESSION_EXPIRED,METHOD_GET,METHOD_POST,METHOD_PUT,METHOD_DELETE,CACHE,USER_TKEY,AUTH_KEY, USER_SIGN_OUT,METHOD_PATCH, COOKIE_SESSION_ID, USER_SKEY} from 'utils/constants';
import {setToCache,getFromCache,removeFromCache} from './querystring';
import {getCookie, setCookie} from 'utils/cookie';

const defaultOpt = {
  method:METHOD_GET,
  mode: "cors",
  credentials: "include",
  headers: {
      "Content-Type": "application/json; charset=utf-8"
  }
}
const defaultPostOpt = {
    method: METHOD_POST,
    mode: "cors",
    credentials: "include",
    headers: {
        "Content-Type": "application/json; charset=utf-8"
    }
}
const defaultUploadPostOpt = {
    method: METHOD_POST,
    mode: "cors",
    credentials: "include",
    bodyType:"form-data"
}
class DataService { 

    // async function
    async deleteRequest(urlkey,params={},options={}){
      //options = {...options,method:METHOD_DELETE};
      if(process.env.DELETE_METHOD === METHOD_GET) {
        /* for dev mode */
        return this.getRequest(urlkey,params,{...options,method:METHOD_GET});
      } else {
        return this.getRequest(urlkey,params,{...options,method:METHOD_DELETE});
      }
    }

    async patchRequest(urlkey,params={},options={}){
      options = {...options,method:METHOD_PATCH};
      return this.postRequest(urlkey,params,options);
    }

    async getRequest(urlkey,params={},options={}){
      let data = {};
      let opt = {...defaultOpt,...options}
      if(app.apis){
        data = await this._sendRequest(urlkey,params,opt);
      }
      else{
        data = await app.apiConfig.then(res=>{
              return this._sendRequest(urlkey,params,opt);
          })
      }
      // console.log('-------urlkey---------'+urlkey);
      return data;
    }
    // async getRequest(urlkey,params={},options={}){
    //   let data = {};
    //   if(app.apis){
    //     data = await this._sendRequest(urlkey,params,options);
    //   }
    //   else{
    //     data = await app.apiConfig.then(res=>{
    //           return this._sendRequest(urlkey,params,options);
    //       })
    //   }
    //   console.log('-------urlkey---------'+urlkey);
    //   return data;
    // }

    async uploadRequest(urlkey, params={}, options={}) {
      if(process.env.POST_METHOD == METHOD_GET){
        return this.getRequest(urlkey,params,{...options,method:METHOD_GET});
      } 
      let data = {};
      options = {...defaultUploadPostOpt,...options};
      if(app.apis){
        data = await this._sendRequest(urlkey,params,options);
      }
      else{
        data = await app.apiConfig.then(res=>{
              return this._sendRequest(urlkey,params,options);
          })
      }
      // console.log('-------urlkey---------'+urlkey);
      return data;
    }
    async putRequest(urlkey,params={},options={}){
      options = {...options,method:METHOD_PUT};
      return this.postRequest(urlkey,params,options);
    }

    async postRequest(urlkey,params={},options={}){
        if(process.env.POST_METHOD == METHOD_GET){
          return this.getRequest(urlkey,params,{...options,method:METHOD_GET});
        } 
        let data = {};
        options = {...defaultPostOpt,...options};
        //options['body'] = JSON.stringify(params);
        if(app.apis){
          data = await this._sendRequest(urlkey,params,options);
        }
        else{
          data = await app.apiConfig.then(res=>{
                return this._sendRequest(urlkey,params,options);
            })
        }
        // console.log('-------urlkey---------'+urlkey);
        return data;
      }

    async _sendRequest(urlkey,params,bodyOpt={method:METHOD_GET,mode: "cors",}){

        let escapeSellerInteraction = params.escapeSellerInteraction ? true : false; 

        let cacheKey = params[CACHE];
        delete params[CACHE];
        let skipToken = !!params.skipToken;
        let userToken = params.userToken;
        delete params['userToken'];
        delete params['skipToken'];
        params = {...app.pageParams,...params};
        let paramsToBody = bodyOpt.method == METHOD_PATCH || bodyOpt.method == METHOD_POST || bodyOpt.method == METHOD_PUT || !!bodyOpt.paramsToBody;
        let url = params.skipappendbaseurl ? urlkey : resolveApiUrl(urlkey,params,!paramsToBody);
        if(paramsToBody){
          if(params)
            if((bodyOpt && bodyOpt["bodyType"] == 'form-data')){
              params["formData"].append('lang', app.pageParams.lang);
              params["formData"].append('orgIdfier', app.pageParams.orgIdfier);
            }
            bodyOpt['body'] = (bodyOpt && bodyOpt["bodyType"] == 'form-data') ? params["formData"] : JSON.stringify(params);
            //bodyOpt['body'] = (bodyOpt && bodyOpt["contentType"] == 'multipart/form-data') ? params["formData"] : JSON.stringify(params);
        }
        let authToken = getFromCache(USER_TKEY) || userToken;
        //let authToken = getFromCache(USER_TKEY) || userToken;
        let tokenCheck = !skipToken && process.env.TOKEN_CHECK == 'true';
        if(tokenCheck && authToken){
          bodyOpt.headers = bodyOpt.headers || {};
          bodyOpt.headers[AUTH_KEY] = authToken;
        }
        //bodyOpt.credentials= 'include';
        //bodyOpt.credentials= 'same-origin';
        // console.log(cacheKey+'-------_sendRequest url---------'+url);
        let data = await (await (fetch(url,bodyOpt)
        .then(res => {
          let contentType = res.headers.get("content-type");
          let sessionExp = res.headers.has(SESSION_EXPIRED);
          authToken = res.headers.get(AUTH_KEY);
          authToken && setToCache(USER_TKEY,authToken);

          //let cookieSessionID = res.headers.get(COOKIE_SESSION_ID);
          //X-Powered-By
//          let cookieSessionID = res.headers.get(COOKIE_SESSION_ID);
//          cookieSessionID && setCookie(USER_SKEY,cookieSessionID);
          
          //console.log('-------header------ '+sessionExp)
          urlkey != "logout" && sessionExp && app.events.trigger(SESSION_EXPIRED);
          let jres = res;
          if(contentType && contentType.includes("application/json")) {
            jres = res.json();
          }   
          if(res.ok && !sessionExp) {
            cacheKey && res.ok && setToCache(cacheKey,jres);
            return jres;
          } else {
            if(!jres) throw {'error':"error"}
            return jres.then(Promise.reject.bind(Promise));
          }
        })
        .catch(err => {
          console.log('Error in data service: ', err);
          cacheKey && removeFromCache(cacheKey);
          throw err;
        })
      ))
      return data
    }

    getCompleteGetURL(urlkey,params={}, bodyOpt={method:METHOD_GET,mode: "cors"}) {
        delete params[CACHE];
        delete params['userToken'];
        delete params['skipToken'];
        params = {...app.pageParams,...params};
        let paramsToBody = bodyOpt.method == METHOD_PATCH || bodyOpt.method == METHOD_POST || bodyOpt.method == METHOD_PUT || !!bodyOpt.paramsToBody;
        let url = params.skipappendbaseurl ? urlkey : resolveApiUrl(urlkey,params,!paramsToBody);
        
        return url;
    }
}
    
export default new DataService()
